export const Locations = (props) => {
  return (
    <div>
      Locations
    </div>
  )
}